import React, { PureComponent } from 'react';

import BannerLayout from '../../layouts/banner';

import Image from '../../../../../containers/assets/instructor-new-valuation-model.png'

class NewValuationModel extends PureComponent {
  render() {
    const { previousShownErrors } = this.props;

    return (
      <BannerLayout
        section="What to expect next"
        subSection="New valuation model"
        alertText="Change in Valuation Method: Price to Earnings Multiples (P/E)"
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <p>Unlike round 1 & 2 when each team’s business value was driven by revenues (i.e. price to sales multiples), in round 3 and 4, each team’s business value will now be driven by profits (price to earnings multiples). As a result, their share price will be driven by profits.</p>
        )}
        visual={(
          <img src={Image} alt="" />
        )
        }
        visualProps={{
          noBorder: true,
          noBackground: true
        }}
      />
    );
  }
}

export default NewValuationModel;


// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/what-to-expect-next/new-valuation-model.js